<div class="row grow header px-5 item-panel">
  <div class="row grow py-3">
    @if (loading) {
      <div class="row grow center-center">
        <div class="loadingSpinner"></div>
      </div>
    }
    @if (!loading) {
      <div class="column grow with-gap center-center">
        <h4>{{ title | uppercase }}</h4>
        <div class="row grow center-center">
          <span class="underlined">{{ content }}</span>
        </div>
      </div>
    }
  </div>
</div>
